import { render, staticRenderFns } from "./ContentPageBreadcrumbs.vue?vue&type=template&id=1a4cdce5"
import script from "./ContentPageBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ContentPageBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports